module.exports = __webpack_public_path__ + "static/media/mision.00f43920.png";